import React, { useState, useCallback , useMemo} from 'react';
// import { useNavigate } from 'react-router-dom';

import Header from './Header';
import '../styles/SunnyHolidayPage.css';

// TODO update functionality of UseEffect and navigation per build errors on cloudflare.

function SunnyHolidayPage() {
  // const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Sample images for the Sunny Holiday collection
  const images = useMemo(() => [
    { id: 1, src: "../collection/sunny-holiday/heart.jpg", alt: "Sunny Holiday Image 1" },
    { id: 2, src: "../collection/sunny-holiday/cube.jpg", alt: "Sunny Holiday Image 2" },
    // { id: 3, src: "/collection/sunny-holiday/3.jpg", alt: "Sunny Holiday Image 3" },
    // { id: 4, src: "/collection/sunny-holiday/4.jpg", alt: "Sunny Holiday Image 4" },
    // { id: 5, src: "/collection/sunny-holiday/5.jpg", alt: "Sunny Holiday Image 5" },
    // { id: 6, src: "/collection/sunny-holiday/6.jpg", alt: "Sunny Holiday Image 6" }
  ], []);

  const openFullScreen = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };

  const closeFullScreen = () => {
    setSelectedImage(null);
    document.body.style.overflow = ''; // Restore scrolling
  };

  const goToPrevious = useCallback(() => {
    setCurrentIndex((prevIndex) => {
      const newIndex = (prevIndex - 1 + images.length) % images.length;
      setSelectedImage(images[newIndex]);
      return newIndex;
    });
  }, [images]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % images.length;
      setSelectedImage(images[newIndex]);
      return newIndex;
    });
  }, [images]);

  // Handle keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;

      if (e.key === 'ArrowLeft') {
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        closeFullScreen();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage, currentIndex, goToNext, goToPrevious]);

  return (
    <div className="sunny-holiday-page">
      <Header />

      <div className="collection-grid">
        {images.map((image, index) => (
          <div className="collection-item" key={image.id}>
            <div className="image-container" onClick={() => openFullScreen(image, index)}>
              <img src={image.src} alt={image.alt} className="actual-img" />
              <div className="overlay">
                <button className="image-icon-btn">
                  <img src="../index/photo.png" alt="View" className="icon-img" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-modal">
          <div className="modal-content">
            <button className="close-btn" onClick={closeFullScreen}>×</button>
            <div className="navigation-container">
              <button className="nav-btn prev-btn" onClick={goToPrevious}>‹</button>
              <img src={selectedImage.src} alt={selectedImage.alt} />
              <button className="nav-btn next-btn" onClick={goToNext}>›</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SunnyHolidayPage;